export const getters = {
  appTitle (state) {
    return state.appTitle
  },
  isAuthenticated (state) {
    return state.isAuthenticated === 'true'
  },
  getUser (state) {
    return state.user
    // return JSON.parse(localStorage.getItem("user"))
  },
  getError (state) {
    return state.error
  },
  getLoading (state) {
    return state.loading
  },
  getRegistrationInfo (state) {
    return state.registrationInfo
  },
  getAccountInfo (state) {
    return state.accountInfo
  },
  getIsAuthorized (state) {
    return state.isAuthorized;
  },
  getMerchant (state) {
    return state.merchant;
  }
}
